<template>
    <i :class="iconClass" :style="styleObject"><span class="text">{{text}}</span></i>
</template>

<script>
    export default {
        name: "IconText",
        props: {
            iconClass: {
                type: String,
                default: 'el-icon-tickets'
            },
            text: String,
            styleObject: Object,
        }
    }
</script>

<style scoped>
    .text{
        margin-left: 4px;
        font-weight: 500;
        color: #909399;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/IconText.vue